import "trix";
import "@rails/actiontext";

// Import Chart.js with all components
import {
  Chart,
  LineController,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";

// Register Chart.js components
Chart.register(
  LineController,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

// Make Chart available globally
window.Chart = Chart;

import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.css";
import "./components";

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('.tom-select').forEach((el) => {
    if (el.tomselect) return; // Prevent re-initialisation
    let settings = {
      create: true,
      sortField: {
        field: "text",
        direction: "asc"
      },
      allowEmptyOption: true,
      placeholder: el.getAttribute('placeholder') || 'Select an option...',
    };

    const tomSelect = new TomSelect(el, settings);

    // Ensure the TomSelect input is focusable
    if (tomSelect.control_input) {
      tomSelect.control_input.setAttribute('tabindex', '0');
    }
  })
})
